import { render, staticRenderFns } from "./NoteSelection.vue?vue&type=template&id=c6a641a6&"
import script from "./NoteSelection.vue?vue&type=script&lang=js&"
export * from "./NoteSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports